module.exports = __webpack_public_path__ + "static/img/one.435d7e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newNmg/one.png
// module id = 8TQq
// module chunks = 1